// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"481":"37fb694f","482":"854fa410"}[chunkId] + ".chunk.css";
};